import React, { useState } from "react";
import ReactDOM from "react-dom";
import { v4 as uuid } from "uuid";
import List from "./components/List/List";
import store from "./utils/store";
import StoreApi from "./utils/storeApi";
import { makeStyles } from "@material-ui/core/styles";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import TopBar from "./components/TopBar";
import SideMenu from "./components/SideMenu";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
// import MuiDialogTitle from "@material-ui/core/DialogTitle";
// import MuiDialogContent from "@material-ui/core/DialogContent";
// import MuiDialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import { useEffect } from "react";
import axios from "axios";
import moment from "moment";
import "./App.css";
import {
  Switch,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";
// import queryString from "query-string";

const useStyle = makeStyles((theme) => ({
  root: {
    minHeight: "100vh",
    background: "#5a605a",
    width: "100%",
    overflowY: "auto",
  },
  listContainer: {
    display: "flex",
  },
}));

export default function App(props) {
  const [data, setData] = useState(store);
  const [open, setOpen] = useState(false);
  const [backgroundUrl, setBackgroundUrl] = useState("");
  const [token, setToken] = useState("");
  const [urlSacOnline, setUrlSacOnline] = useState("");
  const [usuarios, setUsuarios] = useState([]);
  const [preTickets, setPreTickets] = useState([]);
  const [tickets, setTickets] = useState([]);
  const [isLoad, setIsLoad] = useState({
    usuarios: false,
    preTickets: false,
    tickets: false,
    modelos: false,
  });
  const [isLoadPage, setIsLoadPage] = useState(true);
  const [descricao, setDescricao] = useState("");
  const [modalDescricao, setModalDescricao] = useState(false);
  const [modelosCronograma, setModelosCronograma] = useState([]);
  const [modelo, setModelo] = useState(null);
  const [dataCarga, setDataCarga] = useState(moment().format("DD/MM HH:mm"));
  const [modalUsuarios, setModalUsuarios] = useState(false);

  const classes = useStyle();

  const addMoreCard = (title, listId) => {
    const newCardId = uuid();
    const newCard = {
      id: newCardId,
      title,
    };

    const list = data.lists[listId];
    list.cards = [...list.cards, newCard];

    const newState = {
      ...data,
      lists: {
        ...data.lists,
        [listId]: list,
      },
    };
    setData(newState);
  };

  const addMoreList = (title) => {
    const newListId = uuid();
    const newList = {
      id: newListId,
      title,
      cards: [],
    };
    const newState = {
      listIds: [...data.listIds, newListId],
      lists: {
        ...data.lists,
        [newListId]: newList,
      },
    };
    setData(newState);
  };

  const updateListTitle = (title, listId) => {
    const list = data.lists[listId];
    list.title = title;

    const newState = {
      ...data,
      lists: {
        ...data.lists,
        [listId]: list,
      },
    };
    setData(newState);
  };

  const handleToggle = (event, idUsuario) => {
    let isChecked = event.target.checked;
    if (isChecked) {
      habilitarUsuario(idUsuario);
    } else {
      ocultarUsuario(idUsuario);
    }
  };

  const handleClickExibirDescricao = (descricao) => {
    setDescricao(descricao);
    setModalDescricao(true);
  };

  const onDragEnd = (result) => {
    const { destination, source, draggableId, type } = result;
    console.log("destination", destination, "source", source, draggableId);

    if (destination === null) {
      return false;
    }

    if (type === "list") {
      if (destination.index === 0) {
        // nao pode mover antes dos pendentes
        return false;
      }

      if (source.index === destination.index) {
        //usuário nao moveu
        return false;
      }

      const newListIds = data.listIds;
      newListIds.splice(source.index, 1);
      newListIds.splice(destination.index, 0, draggableId);

      alterarSequencia(newListIds);

      return;
    } else {
      if (destination.droppableId === source.droppableId) {
        // moveu na mesma lista
        return false;
      }

      if (destination.droppableId === "pendentes") {
        // valida para nao voltar pra pendnetes
        alert("Um ticket não pode voltar para pendente");
        return false;
      }

      if (source.droppableId === "pendentes") {//NAO ALTERAR PARA NAO ESQUECER
        // aprovarPreTicket(draggableId, destination.droppableId);
        alterarUsuarioTicket(draggableId, destination.droppableId);
      } else {
        alterarUsuarioTicket(draggableId, destination.droppableId);
      }

      const sourceList = data.lists[source.droppableId];
      const destinationList = data.lists[destination.droppableId];
      const draggingCard = sourceList.cards.filter(
        (card) => card.id === draggableId,
      )[0];

      if (source.droppableId === destination.droppableId) {
        const newCards = [...sourceList.cards];
        newCards.splice(source.index, 1);
        newCards.splice(destination.index, 0, draggingCard);
        const newSate = {
          ...data,
          lists: {
            ...data.lists,
            [sourceList.id]: { ...destinationList, cards: newCards },
          },
        };
        setData(newSate);
      } else {
        const newSourceCards = [...sourceList.cards];
        const newDestCards = [...destinationList.cards];
        newSourceCards.splice(source.index, 1);
        newDestCards.splice(destination.index, 0, draggingCard);

        const newState = {
          ...data,
          lists: {
            ...data.lists,
            [sourceList.id]: { ...sourceList, cards: newSourceCards },
            [destinationList.id]: { ...destinationList, cards: newDestCards },
          },
        };
        setData(newState);
      }
    }
  };

  useEffect(() => {
    const url = new URL(window.location.href);
    const urlSacOnline = url.searchParams.get("url");
    const token = url.searchParams.get("token");

    setToken(token);
    setUrlSacOnline(urlSacOnline);

    if (urlSacOnline === null || token === null) {
      alert("Favor informar token e url do sac-online");
      window.location.href = "https://saconline.priorize.com.br";
    }
  }, []);

  useEffect(() => {
    if (token !== "") {
      getData();

      const interval = setInterval(() => {
        getData();
      }, 300000); // 5minutos

      return () => clearInterval(interval); // limpa o intervalo ao desmontar
    }
  }, [token]);

  const getData = async () => {
    isLoad.tickets = false;
    isLoad.preTickets = false;
    setIsLoad(isLoad);
    setIsLoadPage(true);

    if (!isLoad.usuarios || !isLoad.modelos) {
      await Promise.all([
        loadUsuarios(),
        // loadPreTickets(),
        loadTickets(),
        loadModelosCronograma(),
      ]);
    } else {
      await Promise.all([
        // loadPreTickets(),
        loadTickets(),
      ]);
    }
  };

  function capitalizarPrimeiraLetra(str) {
    if (!str) return "";

    return str
      .split(".")
      .map((parte) => parte.trim())
      .filter((parte) => parte.length > 0)
      .map(
        (parte) => parte.charAt(0).toUpperCase() + parte.slice(1).toLowerCase(),
      )
      .join(".");
  }

  const ocultarUsuario = (idUsuario) => {
    for (let usuario of modelo.usuarios) {
      if (usuario._id === idUsuario) {
        usuario.visivel = false;
      }
    }

    let listIdsNew = data.listIds;

    listIdsNew = listIdsNew.filter((it) => it !== idUsuario);

    alterarSequencia(listIdsNew);
  };

  const habilitarUsuario = (idUsuario) => {
    for (let usuario of modelo.usuarios) {
      if (usuario._id === idUsuario) {
        usuario.visivel = true;
      }
    }

    let listIdsNew = data.listIds;
    listIdsNew.push(idUsuario);
    alterarSequencia(listIdsNew, true);
  };

  const alterarSequencia = async (listaIdsNova, recarregarPagina = false) => {
    let idModelo = modelo._id;
    let desc = modelo.desc;

    let localUsuarios = [];

    let seq = 1;

    for (let item of listaIdsNova) {
      let usuarioFind = usuarios.find((it) => it._id === item);
      let usuarioFindModelo = modelo.usuarios.find((it) => it._id === item);

      if (usuarioFind !== undefined && usuarioFindModelo !== undefined) {
        localUsuarios.push({
          _id: usuarioFind._id,
          descricao: usuarioFind.descricao,
          login: usuarioFind.login,
          visivel: usuarioFindModelo.visivel,
          seq,
        });

        seq = seq + 1;
      }
    }

    //aqui adiciona os usuários que não estao visíveis no momento
    for (let usuario of usuarios) {
      if (!listaIdsNova.includes(usuario._id)) {
        localUsuarios.push({
          _id: usuario._id,
          descricao: usuario.descricao,
          login: usuario.login,
          visivel: false,
          seq,
        });
        seq = seq + 1;
      }
    }

    await axios
      .put(
        `${getBaseUrlApi()}/modelos-cronograma/${idModelo}`,
        { modelo: { isPadrao: true, desc, usuarios: localUsuarios } },
        getParametersApi(),
      )
      .then(async (res) => {
        if (recarregarPagina) {
          window.location.reload();
        } else {
          isLoad.modelos = false;
          setIsLoad(isLoad);
          getData();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    if (
      isLoad.tickets &&
      isLoad.preTickets &&
      isLoad.usuarios &&
      isLoad.modelos
    ) {
      criarListas();
    }
  }, [usuarios, preTickets, tickets]);

  const loadUsuarios = async () => {
    await axios
      .get(`${getBaseUrlApi()}/usuarios2`, getParametersApi())
      .then(async (res) => {
        let usuarios = res.data.usuarios;

        usuarios.push({
          _id: "99",
          _rev: "5-2648efd008d06897a183fc0d7d8074b6",
          id: 99,
          codigo: "99",
          descricao: "Não Atribuídos",
          email: "",
          login: "Não Atribuídos",
          senha: "",
          cargo: "",
          status: "A",
          type: "usuario",
          acessoWeb: 1,
        });

        usuarios.sort((a, b) => a.login.localeCompare(b.login));

        for (let usuario of usuarios) {
          usuario.login = capitalizarPrimeiraLetra(usuario.login);
        }

        isLoad.usuarios = true;
        setIsLoad(isLoad);

        setUsuarios(usuarios);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const aprovarPreTicket = async (idTicket, idUsuario) => {
    await axios
      .post(
        `${getBaseUrlApi()}/pre-tickets-aprovar`,
        { idTicket, idUsuario },
        getParametersApi(),
      )
      .then(async (res) => {
        getData();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const alterarUsuarioTicket = async (idTicket, idUsuario) => {
    let usuarioFind = usuarios.find((it) => it._id === idUsuario);
    if (usuarioFind === undefined) {
      alert("Erro contatar administrador!");
    }

    await axios
      .post(
        `${getBaseUrlApi()}/geral/alterar-usuario`,
        { idTicket, usuario: usuarioFind },
        getParametersApi(),
      )
      .then(async (res) => {
        getData();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const alterarDataTicket = async (idTicket, dtEntrega, type) => {
    await axios
      .post(
        `${getBaseUrlApi()}/geral/alterar-data-entrega`,
        { idTicket, dtEntrega, type },
        getParametersApi(),
      )
      .then(async (res) => {
        getData();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const loadPreTickets = async () => {
    await axios
      .post(`${getBaseUrlApi()}/geral/get-pre-tickets`, {}, getParametersApi())
      .then(async (res) => {
        let preTickets = res.data.preTickets;

        isLoad.preTickets = true;
        setIsLoad(isLoad);

        preTickets = preTickets.sort((a, b) => {
          if (a.dtEntrega === null) return 1; // a vai depois de b
          if (b.dtEntrega === null) return -1; // a vai antes de b
          return new Date(a.dtEntrega) - new Date(b.dtEntrega);
        });

        setPreTickets(preTickets);

        // setUsuarios(usuarios);
        // criarListas(usuarios);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const loadTickets = async () => {
    await axios
      .post(`${getBaseUrlApi()}/geral/get-tickets`, {}, getParametersApi())
      .then(async (res) => {
        let ticketsGeral = res.data.tickets;

        isLoad.tickets = true;
        isLoad.preTickets = true;
        setIsLoad(isLoad);

        let tickets = [];
        let preTickets = [];

        for (let ticket of ticketsGeral) {
          if (
            ticket.usuario === null &&
            ticket.origemEmissao === "portalCliente"
          ) {
            preTickets.push(ticket);
          } else {
            tickets.push(ticket);
          }
        }

        tickets = tickets.sort((a, b) => {
          if (a.dtEntrega === null) return 1; // a vai depois de b
          if (b.dtEntrega === null) return -1; // a vai antes de b
          return new Date(a.dtEntrega) - new Date(b.dtEntrega);
        });

        preTickets = preTickets.sort((a, b) => {
          if (a.dtEntrega === null) return 1; // a vai depois de b
          if (b.dtEntrega === null) return -1; // a vai antes de b
          return new Date(a.dtEntrega) - new Date(b.dtEntrega);
        });

        let dataAtual = moment().startOf("day");

        for (let ticket of tickets) {
          if (ticket.dtEntrega !== null) {
            if (dataAtual.isAfter(moment(ticket.dtEntrega).startOf("day"))) {
              ticket.situacao = 99;
            }
          }

          if (
            (ticket.situacao === 0 || ticket.situacao === 1) &&
            ticket.apontamentos.length > 0
          ) {
            ticket.situacao = 2;
          }

          if (ticket.situacao === 0) {
            ticket.situacaoDesc = "Pendente";
            ticket.situacaoCor = "#5a6268";
          } else if (ticket.situacao === 1) {
            ticket.situacaoDesc = "Agendado";
            ticket.situacaoCor = "#36a3f7";
          } else if (ticket.situacao === 99) {
            ticket.situacaoDesc = "Atrasado";
            ticket.situacaoCor = "#f22d4e";
          } else if (ticket.situacao === 2) {
            ticket.situacaoDesc = "Em Atendimento";
            ticket.situacaoCor = "#ffb822";
          }
        }

        ReactDOM.unstable_batchedUpdates(() => {
          setTickets(tickets);
          setPreTickets(preTickets);
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const loadModelosCronograma = async () => {
    await axios
      .post(`${getBaseUrlApi()}/modelos-cronograma`, {}, getParametersApi())
      .then(async (res) => {
        let modelosCronograma = res.data.modelosCronograma;

        if (!modelosCronograma || modelosCronograma.length === 0) {
          alert(
            "Favor comunicar administrador: não possui documentos de modelo de cronograma!",
          );
          return;
        }

        isLoad.modelos = true;
        setIsLoad(isLoad);

        setModelosCronograma(modelosCronograma);
      })
      .catch((error) => {
        console.log(error);
        alert(
          "Erro ao carregar modelos de cronograma. Favor comunicar administrador!",
        );
      });
  };

  const getBaseUrlApi = () => {
    return process.env.REACT_APP_DEV_API_URL_BACKEND_SAC;
  };

  const getParametersApi = () => {
    return {
      headers: {
        "x-access-token": token,
      },
    };
  };

  const criarListas = () => {
    let modelo = null;

    let modeloStorage = localStorage.getItem("modeloCronograma");
    if (modeloStorage !== null) {
      let modeloFind = modelosCronograma.find((it) => it._id === modeloStorage);
      if (modeloFind !== undefined) {
        modelo = JSON.parse(JSON.stringify(modeloFind));
      }
    }

    // Se não achou no localStorage, pega o primeiro modelo disponível
    if (modelo === null && modelosCronograma.length > 0) {
      modelo = JSON.parse(JSON.stringify(modelosCronograma[0]));
    }

    // Validação final (não deveria chegar aqui se loadModelosCronograma funcionou corretamente)
    if (!modelo || !modelo.usuarios) {
      alert(
        "Favor comunicar administrador: não possui documentos de modelo de cronograma!",
      );
      return false;
    }

    // localStorage.setItem("modeloCronograma", modelo._id);

    // Sincronizar usuários novos no modelo (adiciona como visíveis antes de "Não Atribuídos")
    let usuariosNovos = [];
    for (let usuario of usuarios) {
      let usuarioNoModelo = modelo.usuarios.find((u) => u._id === usuario._id);
      if (!usuarioNoModelo) {
        usuariosNovos.push({
          _id: usuario._id,
          descricao: usuario.descricao,
          login: usuario.login,
          visivel: true,
          seq: 0, // será calculado abaixo
        });
      }
    }

    // Se houver usuários novos, reorganizar sequências
    if (usuariosNovos.length > 0) {
      // Encontrar posição do usuário "Não Atribuídos" (ID 99)
      let usuarioNaoAtribuidos = modelo.usuarios.find((u) => u._id === "99");
      let seqNaoAtribuidos = usuarioNaoAtribuidos
        ? usuarioNaoAtribuidos.seq
        : modelo.usuarios.length + 1;

      // Adicionar novos usuários antes de "Não Atribuídos"
      for (let i = 0; i < usuariosNovos.length; i++) {
        usuariosNovos[i].seq = seqNaoAtribuidos + i;
        modelo.usuarios.push(usuariosNovos[i]);
      }

      // Incrementar seq de "Não Atribuídos" e todos depois dele
      for (let usuario of modelo.usuarios) {
        if (
          usuario._id !== "99" &&
          !usuariosNovos.find((u) => u._id === usuario._id)
        ) {
          if (usuario.seq >= seqNaoAtribuidos) {
            usuario.seq += usuariosNovos.length;
          }
        }
      }

      if (usuarioNaoAtribuidos) {
        usuarioNaoAtribuidos.seq += usuariosNovos.length;
      }

      // Salvar modelo atualizado no backend
      axios
        .put(
          `${getBaseUrlApi()}/modelos-cronograma/${modelo._id}`,
          {
            modelo: {
              isPadrao: modelo.isPadrao,
              desc: modelo.desc,
              usuarios: modelo.usuarios,
            },
          },
          getParametersApi(),
        )
        .catch((error) => {
          console.log("Erro ao salvar usuários novos no modelo:", error);
        });
    }

    let localUsuarios = [];

    modelo.usuarios = modelo.usuarios.sort((a, b) => a.seq - b.seq);

    for (let usuario of modelo.usuarios) {
      if (usuario.visivel) {
        let usuarioFind = usuarios.find((it) => it._id === usuario._id);
        if (usuarioFind !== undefined) {
          localUsuarios.push(JSON.parse(JSON.stringify(usuarioFind)));
        }
      }
    }

    //
    let listas = {};
    let listaIds = [];

    listas["pendentes"] = {
      id: "pendentes",
      title: "Pendentes",
      cards: [],
      totalizadorAtrasados: 0,
    };

    if (preTickets.length > 0) {
      for (let item of preTickets) {
        listas["pendentes"].cards.push({
          id: item._id,
          title: item.assunto,
          fantasia: item.cliente.fantasia,
          dataEmissao: moment(item.dataCriacao).format("DD/MM"),
          descricao: item.descricao,
          dtEntrega: item.dtEntrega,
          // type: "pre-ticket",
          type: "ticket",
          situacaoDesc: "Em análise",
          situacaoCor: "#ffb822",
          situacao: item.situacao,
        });
      }
    }

    listaIds.push("pendentes");

    for (let usuario of localUsuarios) {
      listas[usuario._id] = {
        id: usuario._id,
        title: usuario.login,
        cards: [],
        totalizadorAtrasados: 0,
      };

      listaIds.push(usuario._id);
    }

    for (let item of tickets) {
      let usuarioId = "99";
      if (item.usuario !== null) {
        usuarioId = item.usuario._id;
      }

      if (listas[usuarioId] !== undefined) {
        listas[usuarioId].cards.push({
          id: item._id,
          title: item.assunto,
          fantasia: item.cliente.fantasia,
          dataEmissao: moment(item.dataCriacao).format("DD/MM"),
          descricao: item.descricao,
          dtEntrega: item.dtEntrega,
          type: "ticket",
          situacaoDesc: item.situacaoDesc,
          situacaoCor: item.situacaoCor,
          situacao: item.situacao,
        });
      }
    }

    for (let usuario of localUsuarios) {
      if (listas[usuario._id].cards.length > 0) {
        let totalizadorAtrasados = listas[usuario._id].cards.filter(
          (it) => it.situacao === 99,
        ).length;

        listas[usuario._id].totalizadorAtrasados =
          listas[usuario._id].totalizadorAtrasados + totalizadorAtrasados;
      }
    }

    setData({ lists: listas, listIds: listaIds });
    setModelo(modelo);
    setDataCarga(moment().format("DD/MM HH:mm"));
    setIsLoadPage(false);
  };

  return (
    <StoreApi.Provider value={{ addMoreCard, addMoreList, updateListTitle }}>
      <div
        className={classes.root}
        style={{
          backgroundImage: `url(${backgroundUrl})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        <TopBar
          setOpen={setOpen}
          dataCarga={dataCarga}
          isLoadPage={isLoadPage}
          urlSacOnline={urlSacOnline}
          setModalUsuarios={setModalUsuarios}
        />

        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="app" type="list" direction="horizontal">
            {(provided) => (
              <div
                className={classes.listContainer}
                ref={provided.innerRef}
                {...provided.droppableProps}
              >
                {data.listIds.map((listId, index) => {
                  const list = data.lists[listId];
                  return (
                    <List
                      list={list}
                      key={listId}
                      index={index}
                      handleClickExibirDescricao={handleClickExibirDescricao}
                      alterarDataTicket={alterarDataTicket}
                      totalizadorAtrasados={list.totalizadorAtrasados}
                      urlSacOnline={urlSacOnline}
                      ocultarUsuario={ocultarUsuario}
                    />
                  );
                })}
                {/* <InputContainer type="list" /> */}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
        {/* <SideMenu
          setBackgroundUrl={setBackgroundUrl}
          open={open}
          setOpen={setOpen}
        /> */}
      </div>

      <Dialog
        onClose={() => setModalDescricao(false)}
        aria-labelledby="customized-dialog-title"
        open={modalDescricao}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle
          id="customized-dialog-title"
          onClose={() => setModalDescricao(false)}
        >
          Descrição do Ticket
        </DialogTitle>
        <DialogContent dividers>{descricao}</DialogContent>
        <DialogActions>
          <Button onClick={() => setModalDescricao(false)} color="primary">
            Fechar
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        onClose={() => setModalUsuarios(false)}
        aria-labelledby="customized-dialog-title"
        open={modalUsuarios}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle
          id="customized-dialog-title"
          onClose={() => setModalUsuarios(false)}
        >
          Alterar Visualização de Usuários
        </DialogTitle>
        <DialogContent dividers>
          <Table size="small">
            <TableHead>
              <TableRow style={{ backgroundColor: "#343a40", color: "#FFF" }}>
                <TableCell style={{ color: "#fff" }}>
                  <strong>Usuário</strong>
                </TableCell>
                <TableCell style={{ color: "#fff" }} align="center">
                  <strong>Sequência</strong>
                </TableCell>
                <TableCell style={{ color: "#fff" }} align="center">
                  <strong>Visível?</strong>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {modelo?.usuarios.map((usuario) => (
                <TableRow>
                  <TableCell>{usuario.login}</TableCell>
                  <TableCell align="center">{usuario.seq}</TableCell>
                  <TableCell align="center">
                    <Switch
                      checked={usuario.visivel}
                      onChange={(e) => handleToggle(e, usuario._id)}
                      color="primary"
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setModalUsuarios(false)} color="primary">
            Fechar
          </Button>
        </DialogActions>
      </Dialog>
    </StoreApi.Provider>
  );
}
